import { BRAND_LOGO_TYPE } from './general';
import { IdentityLevel } from './registrationFlows';

export interface ApiConfig {
  apiRoot: string;
  apiAddressService: {
    apiRoot: string;
  };
  fusionAuth: {
    domain: string;
    clientId: string;
  };
  brandGroupUrl: string;
  ims: {
    apiRoot: string;
    fusionAuthVersion: string;
  };
  srs: {
    apiRoot: string;
    invitationRoot: string;
  };
  devReturnUrlDomains?: string[];
}

export interface BrandConfig {
  id: string;
  name: string;
  countryISO: string;
  consentId: string;
  urlDisplay: string;
  minimumRegistrationAge?: number;
  designSystem: {
    themeKey?: string;
    logoType?: BRAND_LOGO_TYPE;
    footerLogoType?: BRAND_LOGO_TYPE;
    overrides?: {
      brandMain: string;
      brandSquareMain: string;
    };
  };
  customerService: {
    languages: {
      nl: string;
      eng: string;
      de: string;
    };
  };
  privacyStatement: {
    languages: {
      nl: string;
      eng: string;
      de: string;
    };
  };
  termsAndConditions: {
    languages: {
      nl: string;
      eng: string;
      de: string;
    };
  };
  readMore?: {
    languages?: Record<string, string>;
  };
}

export interface BrandGroupConfig {
  id: string;
  brands: BrandConfig[];
  additionalFooterLogos?: string[];
}

export interface CountryConfig {
  countryIso: string;
  requireStreet: boolean;
  resolveDutchAddress: boolean;
  validation: {
    matchPostcodeAndCity: boolean;
    validateHouseNumber: boolean;
    validateCity: boolean;
    validatePostcode: boolean;
  };
  autoComplete: boolean;
  phoneNumberFormat: string;
}

export enum RegistrationFlowField {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  GENDER = 'gender',
  BIRTH_DATE = 'birthDate',
  POST_CODE = 'postCode',
  STREET = 'street',
  HOUSE_NUMBER = 'houseNumber',
  BOX_NUMBER = 'boxNumber',
  CITY = 'city',
  COUNTRY = 'country',
  PHONE_NUMBER = 'phoneNumber',
}

export interface RegistrationFlowOrchestration {
  identityLevel: IdentityLevel;
  visibleFields: RegistrationFlowField[];
  mandatoryFields: RegistrationFlowField[];
}
